import { useState } from "react";
import { getDryRun, setDryRun } from "../lib/session";

export default function DryRunToggle() {
  const [on, setOn] = useState(getDryRun());
  return (
    <label className="flex items-center gap-1 text-sm cursor-pointer" title="Appends ?dry_run=true to write calls. Server validates without persisting.">
      <input
        type="checkbox"
        checked={on}
        onChange={e => {
          setDryRun(e.target.checked);
          setOn(e.target.checked);
        }}
      />
      <span className={on ? "text-amber-700 font-medium" : "text-slate-600"}>dry-run</span>
    </label>
  );
}
